import React from 'react'
import PropTypes from 'prop-types'
import { isDefined } from '../../../../../lib/utils/common'

const OptionTemplate = ({ labelText, option: { count } }) => (
  <span>
    { labelText }
    { isDefined(count) && <span className='Multiselect-locationCount'>
      {` (${count})`}
    </span> }
  </span>
)

OptionTemplate.propTypes = {
  labelText: PropTypes.string.isRequired,
  option: PropTypes.shape({
    count: PropTypes.number
  })
}

export default OptionTemplate
